import { render, staticRenderFns } from "./WeekTrafficRefactored.vue?vue&type=template&id=672b7074&"
import script from "./WeekTrafficRefactored.vue?vue&type=script&lang=js&"
export * from "./WeekTrafficRefactored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports